import React from 'react';
import { ProductSelectBottomSheet, type ProductSelectionWithQuantity } from '@features/products';
import { useBottomSheet } from '@shared/shell/bottomsheet/useBottomSheet';
import { useToast } from '@shared/hooks/useToast';

interface AddProductsToCollectionBottomSheetProps {
  collectionId: string;
  existingProductIds: Set<string>;
  onClose: () => void;
  onAdd: (params: { collectionId: string; productIds: string[] }) => Promise<unknown>;
}

const AddProductsToCollectionBottomSheet: React.FC<
  AddProductsToCollectionBottomSheetProps
> = ({ collectionId, existingProductIds, onClose, onAdd }) => {
  const { closeBottomSheet } = useBottomSheet();
  const { success, error } = useToast();

  const handleClose = () => {
    onClose();
    closeBottomSheet();
  };

  const handleFinish = async (selections: ProductSelectionWithQuantity[]) => {
    if (selections.length === 0) return;
    try {
      const productIds = selections.map(s => s.product.id);
      await onAdd({ collectionId, productIds });
      success(
        `${selections.length} product${selections.length !== 1 ? 's' : ''} added to collection`
      );
      handleClose();
    } catch {
      error('Failed to add products to collection');
    }
  };

  return (
    <ProductSelectBottomSheet
      title="Add products to collection"
      excludeProductIds={existingProductIds}
      getDisabledCaption={() => 'Already in collection'}
      onClose={handleClose}
      onFinish={handleFinish}
    />
  );
};

export default AddProductsToCollectionBottomSheet;
